import index from '../objects/global/index.js';
import '../objects/global/mr-components.js'; // Import to register custom elements
import { setInstoreFittingRoomMode } from '../objects/global/fitting-room.js';
import { initWishlistHeaderButton } from '../objects/global/header.js';
import { initBirdsnestTvVideoModal } from '../objects/global/birdsnest-tv-video.js';

index();
setInstoreFittingRoomMode();
initWishlistHeaderButton();
initBirdsnestTvVideoModal();
